webpackJsonp([318],{

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersPointTable_vue__ = __webpack_require__(3093);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4ec7f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersPointTable_vue__ = __webpack_require__(5800);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersPointTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4ec7f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersPointTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_filters__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-04-25 11:53:19
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 1
      }
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      // 处理路由参数
      var query = vm.handleSearchFieldType(to.query);
      // 设置搜索参数
      vm.setSearchParams(query);
      // 获取表格数据
      vm.handleTableDataRequest(query);
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // 处理路由参数
    var query = this.handleSearchFieldType(to.query);
    // 获取表格数据
    this.handleTableDataRequest(query);
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     * @typedef 必须重写
     */
    getTableData: function getTableData(params) {
      // 需要重写该方法 返回 Promise 对象
    },

    /**
     * 设置表格数据
     * @param {*} params
     * @typedef 可选重写
     */
    setTableData: function setTableData(params) {
      this.table = params;
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     * @typedef 可选重写
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     * @param {*} params
     * @typedef 可选重写
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @param {*} params
     * @typedef 可选重写
     */
    setPagination: function setPagination(pagination) {
      this.pagination.current_page = Number(pagination.current_page);
      this.pagination.per_page = Number(pagination.per_page);
      this.pagination.total = Number(pagination.total);
    },

    /**
     * 获得搜索参数
     * @description 会同步到路由的query参数中
     * @typedef 可选重写
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     * @typedef 可选重写
     */
    setSearchParams: function setSearchParams(params) {
      for (var key in params) {
        if (this.search.hasOwnProperty(key)) {
          this.search[key] = params[key];
        }
      }
    },

    /**
     * 获得获得路由参数
     * @description
     * @typedef 可选重写
     */
    getRouterQueryParams: function getRouterQueryParams() {
      return this.handleSearchFieldType(this.$route.query);
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     * @typedef 可选重写
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, query, {
          // 用于相同的搜索参数时也触发路由更新
          '-_-': __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('HHmmss')
        })
      });
    },

    /**
     * 获得搜索表单的ref名称
     * @typedef 可选重写
     */
    getSearchFormRef: function getSearchFormRef() {
      return 'searchForm';
    },

    /**
     * 获得请求参数
     * 删除空数组以及空字段
     * @param {*} params
     */
    getRequestParams: function getRequestParams(params) {
      // 设定的搜索参数
      var searchParams = this.getSearchParams();
      // 请求参数
      var requestParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, searchParams, params);
      // 删除空的请求参数
      for (var key in requestParams) {
        // 为数组时必须长度大于0
        if (requestParams[key] instanceof Array && requestParams[key].length === 0) {
          delete requestParams[key];
        }
        // 空字符串或者null时删除字段
        if (requestParams[key] === '' || requestParams[key] === null) {
          delete requestParams[key];
        }
      }
      return requestParams;
    },

    /**
     * 设置请求参数到路由参数
     * 路由在改变参数以后会自动获得表格数据
     */
    setRequestParamsToRouter: function setRequestParamsToRouter(params) {
      // 获得分页参数
      var pagination = this.getPagination();
      // 获得所有请求参数
      var requestParams = this.getRequestParams();
      // 设置路由参数
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, pagination, requestParams, params));
    },

    /**
     * 匹配到搜索参数的类型
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    handleSearchFieldType: function handleSearchFieldType(query) {
      var search = this.getSearchParams();
      var searchType = this.getSearchFieldType();
      var pagination = this.getPagination();
      var params = {};
      // 循环路由参数
      for (var key in query) {
        // 搜索参数
        if (search.hasOwnProperty(key) && query.hasOwnProperty(key)) {
          var value = query[key];
          // 是否存在类型声明
          if (value && searchType.hasOwnProperty(key)) {
            // 根据声明转换数据类型
            value = __WEBPACK_IMPORTED_MODULE_2__core_filters__["default"].dataTypeConve(value, searchType[key]);
          }
          params[key] = value;
        }
        // 分页参数
        if (pagination.hasOwnProperty(key) && query.hasOwnProperty(key)) {
          params[key] = Number(query[key]);
        }
      }
      return params;
    },

    /**
     * 处理表格数据请求
     * @param {*} params
     */
    handleTableDataRequest: function handleTableDataRequest(params) {
      var _this = this;

      params = this.handleRequestParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getPagination(), this.getRequestParams(), params));
      // 获得表格数据
      this.getTableData(params).then(function (res) {
        _this.setTableData(res.data.data);
        _this.setPagination({
          current_page: res.data.current_page,
          per_page: res.data.per_page,
          total: res.data.total
        });
      });
    },

    /**
     * 对发送请求的参数进行处理
     * @param {*} params
     * @typedef 可选重写
     */
    handleRequestParams: function handleRequestParams(params) {
      return params;
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      var pagination = this.getPagination();
      if (pagination.per_page !== val) {
        pagination.per_page = val;
        this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), pagination));
      }
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      var pagination = this.getPagination();
      if (pagination.current_page !== val) {
        pagination.current_page = val;
        this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), pagination));
      }
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this2 = this;

      // 验证填写参数
      var searchForm = this.$refs[this.getSearchFormRef()];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            _this2.setRequestParamsToRouter(params);
          } else {
            _this2.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        this.setRequestParamsToRouter(params);
      }
    },

    /**
     * 重置表单方法
     */
    resetForm: function resetForm() {
      this.$refs[this.getSearchFormRef()].resetFields();
    },
    exportExcelFile: function exportExcelFile(name, request) {
      var _this3 = this;

      var fileName = __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__["a" /* default */].makeName(name);
      this.$store.commit('VISIBLE_LAYOUT_EXPORT_DIALOG', true);
      this.$store.commit('SET_LAYOUT_EXPORT_NAME', fileName + '.xlsx');
      request.then(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__["a" /* default */].exportFile(res.data.data, { fileName: fileName });
        _this3.$store.commit('SET_LAYOUT_EXPORT_PERCENTAGE', 100);
        _this3.$store.commit('SET_LAYOUT_EXPORT_STATUS', 'success');
      }).catch(function () {
        _this3.$store.commit('SET_LAYOUT_EXPORT_STATUS', 'exception');
      });
    },

    /**
     * 导出EXCEL文件
     * @param {*} name
     * @param {*} params
     */
    exportMoreExcelFile: function exportMoreExcelFile(name, params) {
      var self = this;
      var fileName = __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__["a" /* default */].makeName(name);
      var _totalRow = 0;
      var _currentTotalRow = 0;
      var _params = this.handleRequestParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getPagination(), this.getRouterQueryParams(), params));
      __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__["a" /* default */].requestExportFile(this.getTableData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _params, params), {
        fileName: fileName,
        titles: { title: '标题' },
        ArrayObjects: true,
        onStart: function onStart(totalPage, totalRow) {
          _totalRow = totalRow;
          self.$store.commit('VISIBLE_LAYOUT_EXPORT_DIALOG', true);
          self.$store.commit('SET_LAYOUT_EXPORT_NAME', fileName + '-' + totalRow + '.xlsx');
        },
        onFinish: function onFinish(data) {
          self.$store.commit('SET_LAYOUT_EXPORT_STATUS', 'success');
        },
        onProgress: function onProgress(data, total) {
          _currentTotalRow += data.data.length;
          self.$store.commit('SET_LAYOUT_EXPORT_PERCENTAGE', Math.floor(_currentTotalRow / _totalRow * 100));
        },
        onError: function onError(error) {
          self.$store.commit('SET_LAYOUT_EXPORT_STATUS', 'exception');
          throw new Error(error);
        }
      });
    }
  }
});

/***/ }),

/***/ 1525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);

/*
 * excel文件的导出
 * @Author anker.wang
 * @Date: 2018-01-08 11:16:50
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-13 17:43:58
 */




function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }return buf;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 转换对象列表转换为二维数组列表
   * [{}] => [[]]
   * @param {array} arrayObjects 数组对象
   * @param {array} keys 字段顺序列表，使转换后的值顺序保持一致
   * @returns {Array}
   * @constructor
   */
  ArrayObjectsToArrays: function ArrayObjectsToArrays(arrayObjects, keys) {
    var arrays = [];
    // 为数组且数组有内容
    if (arrayObjects && arrayObjects instanceof Array && arrayObjects.length) {
      // 获得标题行
      if (!(keys && keys.length)) {
        keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(arrayObjects[0]);
      }
      // 写入标题行
      arrays.push(keys);
      // 获得数据列
      arrayObjects.forEach(function (arrayObject) {
        var array = [];
        // 必须为对象
        if (arrayObject instanceof Object) {
          // 根据标题行顺序获取内容保障数组顺序
          keys.forEach(function (key) {
            array.push(arrayObject[key]);
          });
        }
        arrays.push(array);
      });
    }
    return arrays;
  },
  exportXlsx: function exportXlsx(arrays, options) {
    options.sheetName = options.sheetName || 'Sheet1';
    options.fileName = options.fileName || 'unnamed';
    var wb = {
      SheetNames: [],
      Sheets: {}
    };

    var ws = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.aoa_to_sheet(arrays);

    /* add worksheet to workbook */
    wb.SheetNames.push(options.sheetName);
    wb.Sheets[options.sheetName] = ws;

    /* bookType can be 'xlsx' or 'xlsm' or 'xlsb' or 'ods' */
    var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
    var wbout = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.write(wb, wopts);

    /* the saveAs call downloads a file on the local machine */
    __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), options.fileName + '.xlsx');
  }
});

/***/ }),

/***/ 3093:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_table_v1__ = __webpack_require__(1524);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_table_v1__["a" /* default */]],
  data: function data() {
    return {
      id: this.$route.query.userid || 0,
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0
      },
      search: {
        points_type: null,
        userid: this.$route.query.userid || 0
      },
      // 搜索字段申明
      searchFieldType: {
        points_type: Number,
        userid: Number
      },
      detail: {
        frozenpoints: 0,
        points: 0,
        spendpoints: 0
      }
    };
  },

  computed: Vuex.mapState({
    options: function options(state) {
      return state.users.userOptions;
    }
  }),
  created: function created() {
    if (this.options.length <= 0) {
      this.$store.dispatch('getUserRelatedOptions');
    }
    this.getUserPoint();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getPointList', params);
    },
    getUserPoint: function getUserPoint() {
      var _this = this;

      request.common('getUserPoints', this.id).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.detail, data);
      });
    }
  })
});

/***/ }),

/***/ 5800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      用户名 (ID: "+_vm._s(_vm.search.userid)+") 零豆明细\n    ")])]),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-row',[_c('el-col',{attrs:{"span":22}},[_c('span',[_vm._v("积分总数: "+_vm._s(_vm.detail.points)+"     冻结积分: "+_vm._s(_vm.detail.frozenpoints)+"     已花费积分: "+_vm._s(_vm.detail.spendpoints))])]),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"span":2}},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"rgb(88,157,248)"},attrs:{"to":{path: '/users/amount?userid='+_vm.id}}},[_c('span',[_vm._v("赏金明细")])])],1)],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",staticClass:"layout-search-form medium",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',[_c('el-form-item',{attrs:{"label":"状态","prop":"points_type"}},[_c('el-select',{attrs:{"placeholder":"请选择类型","clearable":""},model:{value:(_vm.search.points_type),callback:function ($$v) {_vm.$set(_vm.search, "points_type", $$v)},expression:"search.points_type"}},_vm._l((_vm.options.points_type),function(option,index){return _c('el-option',{key:index,attrs:{"label":option.keyword,"value":option.id}})}),1)],1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")])],1)],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"points","label":"零豆数量"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"points_type","label":"类型"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.points_type),function(value){return (value.id === scope.row.points_type)?_c('span',[_vm._v(_vm._s(value.keyword))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reason","label":"原因"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.reason),function(value){return (value.id === scope.row.reason)?_c('span',[_vm._v(_vm._s(value.keyword))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"desc","label":"描述"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updated_at","label":"更新时间"}})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/users-point.86ca61b39331a83e7f1c.js